import { useState } from 'react';
import type { ChangeEvent, JSX } from 'react';

import { THEME_OPTIONS, applyTheme, currentTheme, type Theme } from '../shared/theme/theme';

/**
 * Theme selection.
 *
 * A native `<select>` rather than a custom dropdown: it is keyboard accessible, screen-reader
 * accessible, and correctly behaved on touch without any work from us. A custom listbox would
 * need all of that reimplemented, and this is not where the product's differentiation lies.
 */
export function ThemePicker(): JSX.Element {
  const [theme, setTheme] = useState<Theme>(() => currentTheme());

  const onChange = (event: ChangeEvent<HTMLSelectElement>): void => {
    const next = event.target.value as Theme;
    applyTheme(next);
    setTheme(next);
  };

  return (
    <div className="theme-picker">
      <label className="theme-picker__label" htmlFor="theme-select">
        Theme
      </label>
      <select
        id="theme-select"
        className="theme-picker__select"
        value={theme}
        onChange={onChange}
      >
        {THEME_OPTIONS.map((option) => (
          <option key={option.id} value={option.id}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}
